import { useContext, useRef } from "react";
import { Back, gsap } from "gsap";

import WorkCollection from "./WorkCollection";
import { ProjectsContext } from "../../contexts/projectsContext";

const WorkTabs = () => {
  const tl = useRef(gsap.timeline());
  const prevCollection = useRef(null);

  const expandWork = (e) => {
    tl.current
      .to(e.target, { pointerEvents: "none" })
      .to("body", { pointerEvents: "none" }, "<")
      .to(window, {
        scrollTo: { y: e.target, offsetY: 0 },
        duration: 0.5,
        ease: "Expo.out",
      })
      .to("body", { pointerEvents: "auto" }, "<.2")
      .to(
        e.target.parentElement.children[1],
        {
          scaleY: 1,
          duration: 0.7,
          height: "100%",
          overflow: "auto",
          ease: Back.easeOut.config(0.8),
        },
        "<"
      )
      .to(prevCollection.current, {
        height: 0,
      })
      .to(
        prevCollection.current,
        {
          scaleY: 0,
          duration: 0.5,
          overflow: "hidden",
        },
        "<.2"
      )
      .to(
        prevCollection.current !== null
          ? prevCollection.current.parentElement.children[0]
          : prevCollection.current,
        {
          pointerEvents: "auto",
        },
        "<"
      );

    prevCollection.current = e.target.parentElement.children[1];
  };

  const { projectData } = useContext(ProjectsContext);

  return (
    <section className="work">
      <div className="work-tabs__heading text-R-normal">what i do</div>
      <div className="work-tabs__tab-group">
        <div className="tab-container">
          <h2 onClick={expandWork}>web</h2>
          <WorkCollection data={projectData.web} />
          <div className="tab-container__bg-curtain"></div>
        </div>
        <div className="tab-container">
          <h2 onClick={expandWork}>games</h2>
          <WorkCollection data={projectData.games} />
          <div className="tab-container__bg-curtain"></div>
        </div>
        <div className="tab-container">
          <h2 onClick={expandWork}>animations</h2>
          <WorkCollection data={projectData.animations} />
          <div className="tab-container__bg-curtain"></div>
        </div>
      </div>
    </section>
  );
};

export default WorkTabs;
